// removed by extract-text-webpack-plugin
module.exports = {"sectionTest":"Select2__sectionTest___1VwTz","arrow":"Select2__arrow___1ov7D"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/select/Select2.scss
// module id = 1271
// module chunks = 0